"use client"
import React from "react"

type KlaviyoFormProps = {
    data: {
        _type: "klaviyoBlock"
        klavyoFormId?: string
    }
}

export default function KlaviyoForm({ data }: KlaviyoFormProps) {
    return <div className={`px-16 py-6 klaviyo-form-${data.klavyoFormId}`}></div>
}
